import { Badge } from "@/components/ui/badge";
import { MapPin, Phone, Users } from "lucide-react";

export function OrderCustomerInfo({ order, customerStats, isPickup, restaurantData }) {
  return (
    <div className="bg-gray-50 rounded-xl p-4 space-y-2" data-testid="customer-info-section">
      <div className="flex items-start justify-between gap-2">
        <div className="flex items-start gap-3 min-w-0">
          <div className="w-11 h-11 rounded-full bg-emerald-100 flex items-center justify-center shrink-0">
            <Users className="w-6 h-6 text-emerald-600" />
          </div>
          <div className="min-w-0">
            <span className="block font-extrabold text-gray-900 text-2xl uppercase leading-tight truncate">{order.customer_name || "KAISO"}</span>
            {customerStats && (
              <span className="text-[10px] text-gray-500 flex items-center gap-1 mt-0.5">
                {customerStats.total_orders} pedido{customerStats.total_orders !== 1 ? "s" : ""}
                {customerStats.first_order && <Badge className="bg-blue-100 text-blue-600 text-[9px] py-0 px-1">Nuevo</Badge>}
                {customerStats.loyalty_points > 0 && (
                  <span className="flex items-center gap-0.5 text-amber-600 font-bold">⭐ {customerStats.loyalty_points} pts</span>
                )}
              </span>
            )}
          </div>
        </div>
        <span className="text-xs text-gray-400 shrink-0">
          {new Date(order.created_at).toLocaleTimeString("es-ES", { hour: "2-digit", minute: "2-digit" })}
        </span>
      </div>
      {order.customer_phone ? (
        <div className="flex items-center gap-2 ml-11">
          <Phone className="w-3.5 h-3.5 text-gray-400" />
          <a href={`tel:${order.customer_phone}`} className="text-xs text-blue-600 hover:underline">{order.customer_phone}</a>
          <a href={`https://wa.me/${order.customer_phone.replace(/\D/g, '')}`} target="_blank" rel="noopener noreferrer" className="text-xs text-green-600 hover:underline ml-2">WhatsApp</a>
        </div>
      ) : order.order_type === "delivery" ? (
        <div className="flex items-center gap-2 ml-11 bg-red-50 p-2 rounded border border-red-200">
          <Phone className="w-3.5 h-3.5 text-red-500" />
          <span className="text-xs text-red-600 font-bold">⚠️ TELEFONE FALTANDO</span>
        </div>
      ) : null}
      {order.delivery_address && (
        <div className="flex items-center gap-2 ml-11">
          <MapPin className="w-3.5 h-3.5 text-gray-400" /><span className="text-xs text-gray-600 flex-1">{order.delivery_address}</span>
          {order.delivery_lat && order.delivery_lng && (
            <div className="flex gap-1 shrink-0">
              <a href={`https://waze.com/ul?navigate=true&ll=${order.delivery_lat},${order.delivery_lng}`} target="_blank" rel="noopener noreferrer" className="text-[10px] bg-blue-100 text-blue-700 px-1.5 py-0.5 rounded hover:bg-blue-200" data-testid="waze-link">Waze</a>
              <a href={`https://www.google.com/maps/dir/?api=1&destination=${order.delivery_lat},${order.delivery_lng}&travelmode=driving`} target="_blank" rel="noopener noreferrer" className="text-[10px] bg-green-100 text-green-700 px-1.5 py-0.5 rounded hover:bg-green-200" data-testid="maps-link">Maps</a>
            </div>
          )}
        </div>
      )}
      {isPickup && restaurantData?.address && (
        <div className="flex items-center gap-2 ml-11">
          <MapPin className="w-3.5 h-3.5 text-amber-500" /><span className="text-xs text-gray-600">Retirar em: {restaurantData.address}</span>
        </div>
      )}
    </div>
  );
}
